import { message } from 'antd';
import { AxiosError } from 'axios';
import { I18n } from '@aws-amplify/core';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import type { Response } from '@/types';
import { QUERY_KEYS } from '@/utils/query-keys';
import { Service } from '@/infra/services/action-plan';

type Task = {
	id: string;
	title: string;
	due_date: Date;
	responsible_user_id: string;
};

interface UpdateTaskRequest {
	organization_id: string;
	action_plan_id?: string;
	company_id: string;
	action_plan_task_id: string;
	title: string;
	due_date: Date;
	responsible_user_id: string;
}

interface UpdateTaskResponse {
	status: string;
	message: string;
	data?: Task;
}

export const useUpdateActionPlanTask = () => {
	const queryClient = useQueryClient();

	return useMutation<UpdateTaskResponse, AxiosError<Response>, UpdateTaskRequest>(
		(params) => Service.updateTask(params),
		{
			onError: (err) => {
				message.error(I18n.get(err?.response?.data.message));
			},
			onSuccess: () => {
				queryClient.invalidateQueries([QUERY_KEYS.GET_ACTION_PLAN_TASKS]);
				message.success(I18n.get('Task updated successfully'));
			}
		}
	);
};
